import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "table",
  border: "1"
}
const _hoisted_10 = { class: "w-50per" }
const _hoisted_11 = { class: "w-50per" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "my-2" }
const _hoisted_14 = {
  class: "table",
  border: "1"
}
const _hoisted_15 = { class: "w-50per" }
const _hoisted_16 = { class: "w-50per" }
const _hoisted_17 = {
  key: 3,
  class: "table",
  border: "1"
}
const _hoisted_18 = {
  nowrap: "",
  class: "px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { text: _ctx.$t('guidance.title'), href: '/guidance-plan/list' },
          { text: _ctx.$t('guidance.detail') },
        ]
      }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('guidance.detail')), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadGuidancePlan,
        class: "mx-2",
        disabled: _ctx.loading,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.updateApproval,
        disabled: _ctx.loading,
        color: "primary",
        variant: "flat"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('guidance.approve')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_alert, {
        type: "info",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          (_ctx.planResponse)
            ? (_openBlock(), _createBlock(_component_v_table, {
                key: 0,
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1)),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.name')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.type')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.year')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.month')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.week')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.createdAt')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('guidance.updatedAt')), 1)
                    ])
                  ]),
                  (_ctx.planResponse)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('guidance.title')), 1)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.name), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getPlanTypeText(_ctx.planResponse.type)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.year), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.month || ""), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.week || ""), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.planResponse.createdAt)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.planResponse.updatedAt)), 1)
                        ]),
                        (_ctx.planResponse.parentPlan)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                              _createElementVNode("td", null, [
                                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('guidance.parentPlan')), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.parentPlan.name), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getPlanTypeText(_ctx.planResponse.parentPlan.type)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.parentPlan.year), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.parentPlan.month || ""), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.planResponse.parentPlan.week || ""), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.planResponse.parentPlan.createdAt)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.planResponse.parentPlan.updatedAt)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.planResponse)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: _ctx.$t('guidance.director'),
                    value: 
              _ctx.planResponse.users.director
                ? `${_ctx.planResponse.users.director.lastName}${_ctx.planResponse.users.director.firstName}`
                : ''
            ,
                    variant: "outlined",
                    density: "compact",
                    readonly: "",
                    "hide-details": ""
                  }, null, 8, ["label", "value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    value: 
              _ctx.planResponse.users.chief
                ? `${_ctx.planResponse.users.chief.lastName}${_ctx.planResponse.users.chief.firstName}`
                : ''
            ,
                    label: _ctx.$t('guidance.chief'),
                    density: "compact",
                    variant: "outlined",
                    readonly: "",
                    "hide-details": ""
                  }, null, 8, ["value", "label"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: _ctx.$t('guidance.personInCharge'),
                    value: 
              _ctx.planResponse.users.applicant
                ? `${_ctx.planResponse.users.applicant.lastName}${_ctx.planResponse.users.applicant.firstName}`
                : ''
            ,
                    variant: "outlined",
                    density: "compact",
                    readonly: "",
                    "hide-details": ""
                  }, null, 8, ["label", "value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.planResponse)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            elevation: "2",
            class: "pa-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planResponse.itemList, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  key: i,
                  flat: "",
                  class: "my-2 mx-8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        (item.item.type == 'heading')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(item.item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : (item.item.type == 'text')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("table", _hoisted_9, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_10, _toDisplayString(item.item.name), 1),
                                      _createElementVNode("td", _hoisted_11, [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: item.item.body,
                                          "onUpdate:modelValue": ($event: any) => ((item.item.body) = $event),
                                          filled: "",
                                          density: "compact",
                                          "hide-details": "",
                                          "auto-grow": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : (item.item.type == 'childText')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("h3", _hoisted_13, _toDisplayString(item.item.name), 1),
                                  _createElementVNode("table", _hoisted_14, [
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.item.childTextList, (childItem) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: childItem.childId
                                        }, [
                                          _createElementVNode("th", _hoisted_15, _toDisplayString(`${childItem.childName.lastName}${childItem.childName.firstName}`), 1),
                                          _createElementVNode("td", _hoisted_16, [
                                            _createVNode(_component_v_textarea, {
                                              modelValue: childItem.body,
                                              "onUpdate:modelValue": ($event: any) => ((childItem.body) = $event),
                                              filled: "",
                                              density: "compact",
                                              "hide-details": "",
                                              "auto-grow": ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                        (item.item.type == 'grid')
                          ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _cache[3] || (_cache[3] = _createElementVNode("th", null, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.item.grid.header.cols, (colsItem, c) => {
                                    return (_openBlock(), _createElementBlock("th", { key: c }, _toDisplayString(colsItem), 1))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.item.grid.header.rows, (rowsItem, r) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: r }, [
                                    _createElementVNode("th", _hoisted_18, _toDisplayString(rowsItem), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.item.grid.header.cols.length, (col) => {
                                      return (_openBlock(), _createElementBlock("td", { key: col }, [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: item.item.grid.values[r][col],
                                          "onUpdate:modelValue": ($event: any) => ((item.item.grid.values[r][col]) = $event),
                                          filled: "",
                                          density: "compact",
                                          "hide-details": "",
                                          "auto-grow": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_row, {
      class: "mt-6",
      align: "center",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updatePlan())),
              disabled: _ctx.loading,
              color: "primary",
              variant: "flat",
              block: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}